import { render, staticRenderFns } from "./PreviewSize.vue?vue&type=template&id=f0b95f36&"
import script from "./PreviewSize.vue?vue&type=script&lang=js&"
export * from "./PreviewSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports